// extracted by mini-css-extract-plugin
export default {"container":"home_container__8MrUe","card":"home_card__Y0ugq"};